import { Pipe, PipeTransform } from '@angular/core';
import { KeyValue } from '@angular/common';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  filter,
  find,
  findIndex,
  forEach,
  includes,
  orderBy,
  reduce,
} from 'lodash';

@Pipe({
  name: 'fieldOrder',
  standalone: true,
})
export class FieldOrderPipe implements PipeTransform {
  transform(
    pairs: KeyValue<any, any>[],
    fields: FormlyFieldConfig[],
    name?: string
  ): any[] {
    const flattenedFields: FormlyFieldConfig[] = this.flattenFields(fields);

    return orderBy(pairs, ({ key }) => {
      let index: number = findIndex(flattenedFields, { key });

      if (index < 0) {
        index = this.findIndexWithinDynamicField(
          key,
          name as string,
          flattenedFields
        );
      }

      return index;
    });
  }

  private findIndexWithinDynamicField(
    key: string,
    dynamicFieldKey: string,
    fields: any[]
  ): number {
    return findIndex(
      find(filter(fields, { type: 'dynamic' }), { key: dynamicFieldKey })
        ?.props?.['fields'],
      { key }
    );
  }

  private flattenFields(fields: any[]): any {
    return reduce(
      fields,
      (flattenedFields: any[], field) => {
        if (includes(['divider', 'template'], field.type)) {
          return flattenedFields;
        }

        if (field.type === 'abstractGroup') {
          forEach(field.fields, (_field): void => {
            if (!includes(['divider', 'template'], _field.type)) {
              flattenedFields.push(_field);
            }
          });
        } else {
          flattenedFields.push(field);
        }

        return flattenedFields;
      },
      []
    );
  }
}
